import { useResourceNameModal } from '@hooks/useModal'
import { useCreateApprovalGroup } from '../hooks/useApprovalGroupsManagement'
import { useTranslation } from 'react-i18next'

export const useNewApprovalGroup = () => {
  const { openResourceNameModal } = useResourceNameModal()
  const createApprovalGroup = useCreateApprovalGroup()
  const { t } = useTranslation()

  const newApprovalGroup = () => {
    openResourceNameModal({
      title: t('features.approvalGroupsAdmin.newApprovalGroup'),
      inputLabel: t('features.approvalGroupsAdmin.groupName'),
      onSave: async (name: string) => {
        await createApprovalGroup.mutateAsync({ name })
      },
      toastMessages: {
        success: {
          title: t('features.approvalGroupsAdmin.approvalGroupCreated'),
          content: (name) => t('features.approvalGroupsAdmin.successfullyCreatedApprovalGroup', { name }),
        },
        error: {
          title: t('features.approvalGroupsAdmin.unableToCreateApprovalGroup'),
          content: t('features.approvalGroupsAdmin.failedToCreateApprovalGroup'),
        },
      },
    })
  }

  return { newApprovalGroup }
}
